<template>
  <div>
    <avue-crud
      ref="crud"
      :page.sync="page"
      :option="tableOption"
      :search.sync="search"
      :data="tableData"
      :before-open="beforeOpen"
      @search-change="searchChange"
      @search-reset="searchReset"
      @row-save="addRow"
      v-model="form"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
      <template slot-scope="{ row, size }" slot="usernameSearch">
        <el-input
          placeholder="手机号/邮箱/姓名/译员ID"
          :disabled="disabled"
          clearable
          :size="size"
          v-model="search.nickName"
        ></el-input>
      </template>
      <!-- <template slot="search">
        <div class="d-f align-c w-220 m-r-10">
          <span class="w-85 m-r-10 c-606266">擅长领域:</span>
          <el-select
            class="w-130"
            v-model="industry"
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="item in industryListArr"
              :key="item.fieldId"
              :value="item.fieldId"
              :label="item.fieldName"
              class="p-lr-10"
            >
              {{ item.fieldName }}
              <span v-if="item.isHot == 1" class="p-lr-0">（爆品）</span>
            </el-option>
          </el-select>
        </div>
      </template> -->
      <template slot="menuLeft">
        <el-button
          class="filter-item"
          @click="$refs.crud.rowAdd()"
          type="primary"
          icon="el-icon-circle-plus-outline"
        >
          新增
        </el-button>
      </template>
      <template slot="trIdForm">
        <div class="d-f">
          <el-input
            class="w-250 m-r-20"
            v-model="transId"
            placeholder="请输入译员ID"
            clearable
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="searchTrans"
          >
            搜索
          </el-button>
        </div>
      </template>
      <!--  <template slot="industryListForm">
        <el-checkbox-group v-model="industryIds">
          <el-checkbox
            v-for="item in industryListEnable"
            :key="item.fieldId"
            :label="item.fieldId"
          >
            {{ item.fieldName }}
            <span v-if="item.isHot == 1">（爆品）</span>
          </el-checkbox>
        </el-checkbox-group>
      </template> -->
      <template slot="isMatchNameForm">
        <div class="d-f">
          <el-checkbox-group v-model="mathOrderTypes">
            <el-checkbox label="2">系统推送</el-checkbox>
            <el-checkbox label="1">手动邀请</el-checkbox>
          </el-checkbox-group>
          <span class="c-333 m-l-20">
            说明：系统派单（签约译员自动获得此方式，无需选择）
          </span>
        </div>
      </template>
      <template slot="role" slot-scope="scope">
        <span v-for="(role, index) in scope.row.roleList" :key="index">
          <el-tag>{{ role.roleName }}</el-tag>
          &nbsp;&nbsp;
        </span>
      </template>
      <!-- <template slot="industryList" slot-scope="scope">
        <span v-for="(industry, index) in scope.row.industryList" :key="index">
          {{ industry.fieldName }}
          <span v-if="industry.isHot == 1">（爆品）</span>
        </span>
      </template> -->
      <template slot-scope="scope" slot="status">
        <avue-switch
          inactive-color="#13ce66"
          active-color="#ff4949"
          v-model="scope.row.status"
          @click="switchChange(scope.row)"
        ></avue-switch>
      </template>
      <template slot="createTime" slot-scope="scope">
        <span>{{ formatDate(scope.row.createTime) }}</span>
      </template>
      <template slot="disableTime" slot-scope="scope">
        <span>
          {{
            scope.row.disableTime === '0'
              ? '--'
              : scope.row.disableTime === '-1'
              ? '永久'
              : formatDate(scope.row.disableTime)
          }}
        </span>
      </template>
      <template slot-scope="{ row, index }" slot="menu">
        <el-button type="text" size="mini" @click="handleCreditScore(row)">
          信用分调账
        </el-button>
        <el-button type="text" size="mini" @click="handleOperationLog(row)">
          操作日志
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      :visible.sync="switchVisible"
      title="禁用当前账号"
      width="30%"
      center
      @close="switchClose"
    >
      <el-row style="padding-bottom: 20px">选择禁用时长：</el-row>
      <el-row>
        <el-radio v-model="status" :label="1">
          <el-input
            @focus="status = 1"
            type="number"
            class="self-mini"
            step="1"
            size="mini"
            oninput="if(value>999){value=999
} if (value.startsWith('0')){value=1}"
            onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
            v-model="day"
            :min="1"
            :max="999"
          >
            <template slot="append">天</template>
          </el-input>
        </el-radio>
        <el-radio v-model="status" :label="2" style="padding-left: 20px">
          永久禁用
        </el-radio>
      </el-row>
      <el-row style="padding-top: 20px">
        <el-input
          type="textarea"
          placeholder="请输入禁用理由(非必填)"
          v-model="textarea"
          maxlength="500"
          show-word-limit
          :autosize="{ minRows: 2, maxRows: 5 }"
        ></el-input>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="switchVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSwitch">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="creditScoreVisible"
      v-if="creditScoreVisible"
      title="信用分调账"
      width="30%"
      center
    >
      <el-row style="padding-bottom: 20px">
        {{ currentRow.id }}/{{ currentRow.realname }}
      </el-row>
      <el-row style="padding-bottom: 20px">
        当前记分期内剩余分数
        <span style="font-size: large; padding: 0 5px">
          {{ currentRow.score }}
        </span>
        分
      </el-row>
      <el-row style="padding-bottom: 20px">
        <el-radio v-model="taskType" :label="1">加信用分</el-radio>
        <el-radio v-model="taskType" :label="2">减信用分</el-radio>
      </el-row>
      <el-form
        :label-position="'left'"
        :rules="rules"
        label-width="130px"
        :model="form"
        ref="creditForm"
      >
        <el-form-item label="信用分" prop="score">
          <el-input
            v-model="form.score"
            size="mini"
            type="number"
            :min="1"
            :max="12"
            oninput="if(value>12){value=12
} if (value.startsWith('0')){value=1}"
            onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
          ></el-input>
        </el-form-item>
        <el-form-item label="信用分操作说明" prop="remark">
          <el-input
            type="textarea"
            v-model="form.remark"
            placeholder="请输入操作理由,将展示给质控老师"
            maxlength="500"
            show-word-limit
            :autosize="{ minRows: 2, maxRows: 5 }"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="creditScoreVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCreditScore('creditForm')">
          确 定
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="operationLogVisible"
      title="操作日志"
      width="80%"
      v-if="operationLogVisible"
    >
      <avue-crud
        :data="logListData"
        :option="logOption"
        id="log"
        :table-loading="logTableLoading"
      >
        <template slot="createTime" slot-scope="scope">
          <span>{{ formatDate(scope.row.createTime) }}</span>
        </template>
      </avue-crud>
    </el-dialog>
  </div>
</template>

<script>
import {
  list,
  updateAbilityQcStatus,
  updateAbilityQcScore,
  qcLogList,
  industry,
  getAllEnableField,
  getQcInfo,
} from '@/api/qc/manage';
import { addObj, putObj } from '@/api/admin/user';
import { insertTrAbilityQc, checkTrAbilityQc } from '@/api/dot/qc';
import { statistics } from '@/api/dot/flow';
import { tableOption } from '@/const/crud/qc/manage';
import { mapGetters, mapState } from 'vuex';
import { formatDate } from '@/util/date';

export default {
  data() {
    return {
      logOption: {
        addBtn: false,
        menu: false,
        align: 'center',
        menuAlign: 'center',
        column: [
          {
            label: '操作类型',
            row: true,
            span: 24,
            prop: 'type',
            type: 'select',
            dicData: [
              {
                label: '修改状态',
                value: 1,
              },
              {
                label: '调整信用分',
                value: 2,
              },
            ],
          },
          {
            label: '操作前',
            row: true,
            span: 24,
            addDisplay: false,
            prop: 'originValue',
          },
          {
            label: '操作后',
            row: true,
            span: 24,
            addDisplay: false,
            prop: 'newValue',
          },
          {
            label: '说明',
            row: true,
            span: 24,
            addDisplay: false,
            prop: 'remark',
          },
          {
            label: '操作人',
            minWidth: 80,
            addDisplay: false,
            prop: 'updateUser',
          },
          {
            label: '操作时间',
            prop: 'createTime',
            minWidth: 120,
            addDisplay: false,
          },
        ],
      },
      rules: {
        score: [{ required: true, message: '请输入信用分', trigger: 'blur' }],
        remark: [
          { required: true, message: '请输入信用分操作说明', trigger: 'blur' },
        ],
      },
      dic: [
        {
          label: '启用',
          value: 'y',
        },
        {
          label: '禁用',
          value: 'n',
        },
      ],
      logTableLoading: false,
      creditScoreVisible: false,
      operationLogVisible: false,
      switchVisible: false,
      dialogVisible: false,
      dialogLimitTime: 0,
      dialogWordCount: 0,
      dialogFlowId: 0,
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      logPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      currentRow: {},
      industry: [],
      transId: null,
      search: {
        nickName: '',
        industryCode: null,
      },
      logListData: [],
      tableData: [],
      taskType: 1,
      day: null,
      status: 1,
      textarea: '',
      tableOption: tableOption,
      staParams: null,
      industryListArr: [],
      industryIds: [],
      mathOrderTypes: [],
      showIndustryNotice: false,
      form: {},
      industryListEnable: [], //有效领域
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  created: function () {},
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  mounted() {
    this.getList(this.search);
    this.getIndustryList();
    this.getAllEnableField();
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '质控管理',
    };
    this.statistics();
  },
  methods: {
    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },
    searchTrans() {
      console.log(this.form);
      if (!this.transId) {
        return;
      } else {
        getQcInfo({
          id: this.transId,
        }).then((res) => {
          this.form.id = res.data?.data?.id;
          this.form.realname = res.data?.data?.realname;
          this.form.username = res.data?.data?.username;
          this.form.password = res.data?.data?.password;
        });
      }
    },
    /*  beforeOpen(done, type) {
      window.boxType = type;
      const validateIndustry = (rule, value, callback) => {
        if (!this.industryIds.length) {
          callback(new Error('请输入擅长领域'));
        } else {
          callback();
        }
      };
      const validateOrderType = (rule, value, callback) => {
        if (!this.mathOrderTypes.length) {
          callback(new Error('请选择订单获取方式'));
        } else {
          callback();
        }
      };
      let industry = this.findObject(this.tableOption.column, 'industryList');
      industry.rules = [
        { required: true, validator: validateIndustry, trigger: 'change' },
      ];
      let orderType = this.findObject(this.tableOption.column, 'isMatchName');
      orderType.rules = [
        { required: true, validator: validateOrderType, trigger: 'change' },
      ];
      this.industryIds = [];
      this.mathOrderTypes = [];
      // 若是编辑、查看回显角色名称
      if (['edit', 'views'].includes(type)) {
        this.industryIds = this.form?.industryList?.map((item) => {
          return item.fieldId;
        });
        this.mathOrderTypes = this.form?.isMatch?.split(',');
      } else if (type === 'add') {
        this.transId = null;
        // 若是添加领域列表设置为空
        this.industryIds = [];
        this.mathOrderTypes = [];
      }
      done();
    }, */

    // 获取领域列表
    getIndustryList() {
      industry({}).then((res) => {
        this.industryListArr = res.data?.data;
      });
    },

    // 获取有效领域
    getAllEnableField() {
      getAllEnableField({}).then((res) => {
        this.industryListEnable = res.data?.data;
      });
    },

    // 新增
    addRow(row, done, loading) {
      if (row.staffId !== '') {
        insertTrAbilityQc({
          username: row.username,
          realname: row.realname,
          password: row.password,
          staffId: row.id,
          id: row.id,
          fieldId: this.industryIds.join(','),
          isSign: row.isSign,
          operaFlag: 1,
          operator: this.userInfo.realname,
          isMatch: this.mathOrderTypes.join(','),
        }).then((res) => {
          let data = res.data.data;
          if (data > 0) {
            done();
            this.$refs.crud.searchReset();
            this.getList(this.search);
          } else {
            this.$message.error('消息插入tr_ability_qc表失败');
          }
        });
      }

      statistics(
        Object.assign(
          {
            event_name: '新增质控',
            event_type: 'click',
            class_name: 'checkTrAbilityQc',
            class_url: '/dotadmin/dotadmin/qc/checkTrAbilityQc',
            event_params: '{id: row.staffId}',
          },
          this.staParams,
        ),
      );
    },

    submitSwitch() {
      this.switchVisible = false;
      if (this.status === 1 && !this.day) {
        this.$message.error('请填写禁用时长');
        return;
      }
      updateAbilityQcStatus(
        Object.assign({
          staffId: this.currentRow.staffId,
          status: this.currentRow.status ? 'n' : 'y',
          days: this.status === 1 ? this.day : -1,
          remark: this.textarea,
          operator: this.userInfo.realname,
        }),
      ).then((res) => {
        let code = res.data.data;
        if (code > 0) {
          this.$message({
            type: 'success',
            message: '禁用成功!',
          });
          this.searchChange();
        } else if (code === -1) {
          this.$message.error('参数不能为空');
        } else if (code === -2) {
          this.$message.error('数据不存在');
        } else if (code === -3) {
          this.$message.error('状态已修改');
        } else {
          this.$message.error('未知错误，请联系系统管理员');
        }
      });
    },
    submitCreditScore(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.taskType === 1 &&
            parseInt(this.form.score) + this.currentRow.score > 12
          ) {
            this.$message.error('加信用分不得超过12');
            return false;
          }

          if (
            this.taskType === 2 &&
            this.currentRow.score - parseInt(this.form.score) < 0
          ) {
            this.$message.error('减信用分不得超过当前剩余分数');
            return false;
          }

          this.creditScoreVisible = false;
          updateAbilityQcScore(
            Object.assign({
              staffId: this.currentRow.staffId,
              score:
                this.taskType === 1
                  ? this.currentRow.score + parseInt(this.form.score)
                  : this.currentRow.score - parseInt(this.form.score),
              remark: this.form.remark,
              operator: this.userInfo.realname,
            }),
          ).then((res) => {
            let code = res.data.data;
            if (code > 0) {
              this.$message({
                type: 'success',
                message: '启用成功!',
              });
              this.searchChange();
            } else if (code === -1) {
              this.$message.error('参数不能为空');
            } else if (code === -2) {
              this.$message.error('分数不符合要求');
            } else if (code === -3) {
              this.$message.error('数据不存在');
            } else {
              this.$message.error('未知错误，请联系系统管理员');
            }
          });
          statistics(
            Object.assign(
              {
                event_name: '信用分调账',
                event_type: 'click',
                class_name: 'updateAbilityQcScore',
                class_url: '/dotadmin/manage/updateAbilityQcScore',
                event_params:
                  '{staffId: this.currentRow.staffId, score: this.taskType === 1 ? (this.currentRow.score + parseInt(this.form.score)): (this.currentRow.score - parseInt(this.form.score)), remark: this.form.remark, operator: this.userInfo.realname}',
              },
              this.staParams,
            ),
          );
        } else {
          return false;
        }
      });
    },
    logList(page, params) {
      this.logTableLoading = true;
      qcLogList(
        Object.assign(
          {
            staffId: this.currentRow.staffId,
          },
          params,
        ),
      ).then((res) => {
        if (res.data.data) {
          this.logListData = res.data.data;
          this.logTableLoading = false;
        } else {
          this.logListData = [];
          this.logTableLoading = false;
        }
      });
      statistics(
        Object.assign(
          {
            event_name: '操作日志',
            event_type: 'click',
            class_name: 'qcLogList',
            class_url: '/dotadmin/manage/qcLogList',
            event_params: '{staffId: this.currentRow.staffId}',
          },
          this.staParams,
        ),
      );
    },
    logSizeChange(pageSize) {
      this.logPage.pageSize = pageSize;
    },
    logCurrentChange(current) {
      this.logPage.currentPage = current;
    },
    handleCreditScore(row) {
      this.currentRow = row;
      this.creditScoreVisible = true;
    },
    handleOperationLog(row) {
      this.currentRow = row;
      this.operationLogVisible = true;
      this.logList();
    },
    switchClose() {
      this.searchChange();
    },
    switchChange(row) {
      this.currentRow = row;
      if (row.status) {
        this.switchVisible = true;
        this.status = 1;
        this.day = null;
        this.textarea = null;
      } else {
        this.$confirm(
          row.disableTime === '-1'
            ? '当前账号处于永久禁用状态'
            : '当前账号禁号到期时间' +
                this.formatDate(row.disableTime) +
                ',确定启用？',
          '启用当前账号',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          },
        )
          .then(() => {
            updateAbilityQcStatus(
              Object.assign({
                staffId: row.staffId,
                status: row.status ? 'n' : 'y',
                days: null,
                remark: null,
                operator: this.userInfo.realname,
              }),
            ).then((res) => {
              let code = res.data.data;
              if (code > 0) {
                this.$message({
                  type: 'success',
                  message: '启用成功!',
                });
                this.searchChange();
              } else if (code === -1) {
                this.$message.error('参数不能为空');
              } else if (code === -2) {
                this.$message.error('数据不存在');
              } else if (code === -3) {
                this.$message.error('状态已修改');
              } else {
                this.$message.error('未知错误，请联系系统管理员');
              }
            });
          })
          .catch(() => {
            this.searchChange();
          });
      }
    },
    btnReturnSuccess(msg = '提交成功', path = '/refresh', fn) {
      this.$message.success({
        message: msg,
        duration: 1500,
        onClose: () => {
          if (fn) {
            fn();
          }
          this.$router.replace({
            path: path || '/refresh',
          });
        },
      });
    },
    btnReturnFail(msg = '提交失败', path = '/refresh', fn) {
      this.$message.error({
        message: msg,
        duration: 1500,
        onClose: () => {
          if (fn) {
            fn();
          }
          this.$router.replace({
            path: path || '/refresh',
          });
        },
      });
    },

    // 清空搜索
    searchReset() {
      this.industry = [];
    },

    searchChange(form, done) {
      this.search.industryCode = this.industry.join(',');
      this.page.currentPage = 1;
      this.getList(this.search);
      if (done) {
        done();
      }
      statistics(
        Object.assign(
          {
            event_name: '搜索',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },
    formatDate(time) {
      let date = new Date(parseFloat(time));
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    },
    getList(params) {
      list(
        Object.assign(
          {
            current: this.page.currentPage,
            size: this.page.pageSize,
          },
          params,
        ),
      ).then((res) => {
        this.tableData = res.data?.data?.records.map((item) => {
          return { ...item, status: item.status == 'y' ? false : true };
        });
        this.page.total = res.data?.data?.total;
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList(this.search);
    },
    currentChange(current) {
      this.page.currentPage = current;
      this.getList(this.search);
    },
  },
};
</script>
<style lang="scss" scoped>
.avue-view {
  background: #ffffff;
  padding: 20px;
}
:deep(.el-button--small) {
  padding: 9px 10px !important;
}
:deep(
    .el-select-dropdown
      .el-scrollbar
      .el-scrollbar__view
      .el-select-dropdown__item
  ) {
  padding: 0 10px !important;
}
:deep(.avue-group--card:last-child) {
  margin-bottom: 0 !important;
}
.el-table__body tr.hover-row.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped > td,
.el-table__body tr.hover-row > td {
  background-color: unset;
}

.el-table__expanded-cell[class*='cell'] {
  padding: 10px 10px 10px 60px;
}
:deep(.el-table__expanded-cell) {
  tr.hover-row {
    background-color: unset !important;
    td {
      background-color: unset !important;
    }
  }
}

:deep(.el-table__expanded-cell[class*='cell']) {
  padding: 10px;
}
:deep(#log .el-form) {
  max-height: 600px;
  overflow: auto;
}
.dialog-div {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.slef-footer {
  display: flex;
  justify-content: space-around;
}
</style>
